// extracted by mini-css-extract-plugin
export default {"createTemplate":"no-templates-created-modal_createTemplate__PaGLa"};